import { render, staticRenderFns } from "./ModalDeleteMediaItem.vue?vue&type=template&id=56f7efe6&scoped=true"
import script from "./ModalDeleteMediaItem.vue?vue&type=script&lang=js"
export * from "./ModalDeleteMediaItem.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteMediaItem.vue?vue&type=style&index=0&id=56f7efe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f7efe6",
  null
  
)

export default component.exports